import * as React from "react";
import SensorChannelCreateForm from "../components/SensorChannelCreateForm";

export default function SensorChannelCreatePage() {
  return <SensorChannelCreateForm />;
}